import React from 'react';
import { t } from 'Src/i18n';
import { TransportDetails } from 'Components/widgets/be-transport-details/transport-details/TransportDetails';
import { Tag } from 'Components/frameworks/tag/Tag';
import { TransportsDetailsCarbonEmissions } from 'Components/widgets/be-transport-details/TransportsDetailsCarbonEmissions';
type TransportsDetailsProps = {
  tag?: 'cheapest' | 'fastest';
  theme: 'mobile' | 'desktop';
  inbound?: TransportDetail;
  outbound?: TransportDetail;
  isTransportRecommended?: boolean;
  className?: string;
};
export function TransportsDetails({
  tag,
  theme,
  inbound,
  outbound,
  isTransportRecommended,
  className,
}: TransportsDetailsProps) {
  const baggageMoreInfoLabel = t('common.transport.baggageMoreInfoLabel');
  const baggageLandingPageUrl = t('common.transport.baggageLandingPageUrl');
  return (
    <div className={className} data-testid="TransportsDetails">
      <div className="h-full rounded-12 border-0 bg-white shadow-bottomDiffuse">
        <div className="h-fit pt-20">
          {tag && (
            <Tag className="mx-20 mb-10">
              {t(
                `booking.transport.sort.${tag === 'cheapest' ? 'cheapestFlightLabel' : 'fastestFlightLabel'}`,
              )}
            </Tag>
          )}
          {inbound && (
            <TransportDetails
              theme={theme}
              isInbound
              transportDetail={inbound}
              isTransportRecommended={isTransportRecommended}
            />
          )}
          {outbound && (
            <TransportDetails
              theme={theme}
              transportDetail={outbound}
              isTransportRecommended={isTransportRecommended}
            />
          )}
        </div>
        {baggageMoreInfoLabel && baggageLandingPageUrl && (
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={baggageLandingPageUrl}
            className="flex w-full justify-start px-20 pb-20 text-12 underline"
          >
            {t('common.transport.baggageMoreInfoLabel')}
          </a>
        )}
        <TransportsDetailsCarbonEmissions inbound={inbound} outbound={outbound} />
      </div>
    </div>
  );
}
